module.exports = __webpack_public_path__ + "img/2.b92c42ca.png";